<ion-card>
    <ion-item lines="full" color="light">
        <ion-icon slot="start" size="large" color="danger" name="cloud-offline-outline"></ion-icon>
        <ion-label>{{environment.edgeShortName}} ist offline</ion-label>
    </ion-item>
</ion-card>
